<template>
  <form class="pb-5">
    <div class="form-group">
      <label class="common__required-item">Tutor ID</label>
      <p v-if="isEdit">{{ contents.id }}</p>
      <ValidationProvider name="Tutor ID"  rules="required|integer" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.id">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">First Name</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.firstName">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Middle Name</label>
      <ValidationProvider rules="" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.middleName">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">Last Name</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.lastName">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Position</label>
      <SelectPositionInput class="form-control w-25" v-model="contents.position"/>
    </div>
    <div class="form-group">
      <label>Nationality</label>
      <NationalityInput class="form-control w-25" v-model="contents.nationality"/>
    </div>
    <div class="form-group">
      <label class="common__required-item">Phone</label>
      <ValidationProvider
        :rules="{
          required: { allowFalse: true },
          regex: /^0[1-9][0-9]{0,4}-[0-9]{1,5}-[0-9]{1,5}$/ }"
        v-slot="{ errors }"
      >
        <input type="text" class="form-control" v-model="contents.phone1">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">住所</label>
      <ValidationProvider rules="required|max:500" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.addressJapanese">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">Address</label>
      <ValidationProvider rules="required|max:500" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.address">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">Hire Date</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <DateInput v-model="contents.hireDate" />
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">Email 1</label>
      <ValidationProvider rules="required|email" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.email1">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Email 2</label>
      <ValidationProvider rules="email" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.email2">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Emergency 1</label>
      <input type="text" class="form-control" v-model="contents.emergencyContact1">
    </div>
    <div class="form-group">
      <label>Emergency 2</label>
      <input type="text" class="form-control" v-model="contents.emergencyContact2">
    </div>
    <div class="form-group">
      <label class="common__required-item">Birthday</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <div class="w-25">
          <DateInput v-model="contents.birthday" />
        </div>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">Gender</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <select class="form-control w-25" v-model="contents.gender">
          <option :value="0">male</option>
          <option :value="1">female</option>
          <option :value="2">other</option>
        </select>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Leave date</label>
      <DateInput v-model="contents.leaveDate" />
    </div>
    <div class="form-group">
      <label>Educational background</label>
      <input type="text" class="form-control" v-model="contents.academicBackground">
    </div>
    <div class="form-group">
      <label>Teach Exp</label>
      <input type="text" class="form-control" v-model="contents.teachingExperience">
    </div>
    <div class="form-group">
      <label>Total Exp</label>
      <input type="text" class="form-control" v-model="contents.totalExperience">
    </div>
    <div class="form-group">
      <label class="common__required-item">LMS UserID</label>
      <ValidationProvider name="LMS UserID" rules="required|integer" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.lmsUserId">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label class="common__required-item">LMS AccessToken</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.lmsToken">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Priority Waiting flag</label>
      <div>
        <label class="checkbox">
          <input type="checkbox" v-model="contents.waitingPriority" :value="1" />
        </label>
      </div>
    </div>
    <div class="form-group">
      <label>Note</label>
      <ValidationProvider rules="max:500" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="contents.note">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
  </form>
</template>

<script lang="ts">
import _ from 'lodash'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { extend, ValidationProvider } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import NationalityInput from '@/components/parts/inputItem/NationalityInput.vue';
import SelectPositionInput from '@/components/parts/inputItem/SelectPositionInput.vue';
import DateInput from '@/components/parts/inputItem/TutorDateInput.vue';
import { RootState } from '@/store/types';
import { Position } from '@/store/master/types';
import { Tutor } from '@/store/tutors/types';

// バリデーションルール
extend('required', rules.required);
extend('required', { message: 'required.' });

extend('max', rules.max);
extend('max', { message: 'There are too many characters.' });

extend('email', rules.email);
extend('email', { message: 'This is an incorrect or invalid email address.' });

extend('regex', rules.regex);
extend('regex', { message: 'Please enter a phone number with hyphen.' });

extend('regex', rules.regex);
extend('regex', { message: 'Please enter a phone number with hyphen.' });

extend('integer', rules.integer);
extend('integer', { message: 'Please enter a {_field_} must be a number.' });

@Component({
  components: {
    ValidationProvider,
    DateInput,
    NationalityInput,
    SelectPositionInput,
  },
})
export default class TutorInputForm extends Vue {
  @Prop() value!: Tutor|null

  @Prop() tutorId?: string

  private get isEdit(): boolean {
    return !_.isUndefined(this.tutorId)
  }

  private get masterPositions(): Position[] {
    return (this.$store.state as RootState).master.positions
  }

  contents: Object = {
    id: null,
    firstName: null,
    middleName: null,
    lastName: null,
    position: null,
    nationality: null,
    phone1: null,
    address: null,
    addressJapanese: null,
    hireDate: null,
    email1: null,
    email2: null,
    emergencyContact1: null,
    emergencyContact2: null,
    birthday: null,
    gender: null,
    leaveDate: null,
    academicBackground: null,
    teachingExperience: null,
    totalExperience: null,
    lmsUserId: null,
    lmsToken: null,
    waitingPriority: null,
    note: null,
  }

  created() {
    if (this.$route.params.editingTutor) {
      // もし編集情報があるならそれを表示
      this.contents = JSON.parse(this.$route.params.editingTutor)
    } else if (this.tutorId) {
      // ID指定されている場合はIDを元にチューター情報取得
      this.$store.dispatch('getTutor', { tutorId: this.tutorId })
        .then(() => {
          const tutor: Tutor = _.cloneDeep(this.$store.getters.findTutorById(this.tutorId))
          this.contents = {
            ...tutor,
            birthday: tutor.birthday && tutor.birthday.toDate(),
            hireDate: tutor.hireDate && tutor.hireDate.toDate(),
            leaveDate: tutor.leaveDate && tutor.leaveDate.toDate(),
          }
        })
    }
  }

  @Watch('contents', { deep: true })
  noticeChange(contents: Tutor) {
    this.$emit('input', contents)
  }
}
</script>
